import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import hi from "./locales/hi.json";
import bn from "./locales/bn.json";
import gu from "./locales/gu.json";
import ml from "./locales/ml.json";
import mr from "./locales/mr.json";
import pa from "./locales/pa.json";
import kn from "./locales/kn.json";
import ta from "./locales/ta.json";
import te from "./locales/te.json";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      hi: { translation: hi },
      bn: { translation: bn },
      gu: { translation: gu },
      ml: { translation: ml },
      mr: { translation: mr },
      pa: { translation: pa },
      kn: { translation: kn },
      ta: { translation: ta },
      te: { translation: te },
    },
    lng: "en", // default language
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

export default i18n;